import { NotAvailableReason } from './not-available-reason';
import { TeamContactInfo } from './team-info';
export interface ClientSettings {
  templates: TriggerTemplate[];
  placeholders?: TriggerPlaceholder[];
  office365Id?: string;
  userHash?: string;
  settings?: {
    value: string;
  };
  environment: {
    name: string;
    version: string;
  };
  tenant?: {
    crmId: string;
    tenantName: string;
    hasPlanhatEnabled: boolean;
    allowToSharePii: boolean;
  };
  isLicenseFailed?: boolean;
  responsibilityProfiles?: UserResponsibilityProfile[];
  hasContactCenterLicense?: boolean;
  isTenantSuspended?: boolean;
  notAvailableReasons?: NotAvailableReason[];
  outboundServices?: TeamContactInfo[];
  isDefault?: boolean;
  belongsToAnyTeam?: boolean;
  configurationSettings?: ConfigurationSettings;
}

export interface ConfigurationSettings {
  basePollingDefaultTimeoutSec: number;
  basePollingStartingFailureIntervalSec: number;
  basePollingMaxRetryTimeoutSec: number;
  presencePollingDefaultTimeoutSec: number;
  authTeamsTokenTimeoutSec: number;
}

export interface TriggerTemplate {
  callType: string;
  callOrigin: {
    internal: boolean;
    external: boolean;
    pstn: boolean;
    outbound: boolean;
    externalTask: boolean;
    instantMessaging: boolean;
    email: boolean;
  };
  triggerType: TriggerType;
  triggers: Trigger[];
}

export interface Trigger {
  id: string;
  name: string;
  url: string;
  httpMethod: string;
  position: number;
  openInBrowser: boolean;
  body: string;
  multipartFormData?: KeyValue[];
  authorization: Authorization;
  headers: KeyValue[];
  response: {
    wait: boolean;
    waitTimeout: string;
    timeoutSec: number;
  };
  command?: {
    path: string;
    arguments: string;
  };
}

export interface UserResponsibilityProfile {
  id: string;
  name: string;
  active: boolean;
  isDuty: boolean;
}

export enum TriggerType {
  Ringing = 'Ringing',
  Accepted = 'Accepted',
  TaskTerminated = 'TaskTerminated',
}

export type TriggerPlaceholder =
  | '$(Caller.+TelNumber)'
  | '$(Caller.TelNumber)'
  | '$(Caller.DisplayName)'
  | '$(Caller.Id)'
  | '$(User.Id)'
  | '$(User.Email)'
  | '$(User.DisplayName)'
  | '$(User.Upn)'
  | '$(Random.Guid)';

export interface KeyValue {
  key: string;
  value: string;
}

export interface Authorization {
  type: AuthorizationType;
  password?: string;
  userName?: string;
  applicationId?: string;
  scopes?: string[];
}

export enum AuthorizationType {
  None = 'None',
  Basic = 'Basic',
  Scopes = 'Scopes',
  AccessToken = 'AccessToken',
}
export enum CallType {
  Nimbus = 'Nimbus',
  PeerToPeer = 'PeerToPeer',
}
